"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.devicesCommon_de_de = void 0;
function devicesCommon_de_de() {
    return {
        "devices.errors.nodevicefoundforpin": "Kein Gerät gefunden für diesen Code",
        "devices.errors.user.user_not_found": "Benutzer nicht gefunden",
        "devices.errors.user.email_already_exists": "Benutzer existiert bereits",
        "devices.errors.user.invalid_password": "Falsches Passwort",
        "devices.pairing.message": "Verbinden Sie Ihren Browser, Fernseher oder Tablet",
        "devices.pairing.submessage": "Nachdem Sie Ihr Gerät mit dem Backoffice verbunden haben, können Sie von dort aus bequem neue Inhalte auf Ihr Gerät übertragen.",
        "devices.pairing.firststep": "Bitte öffnen Sie ${devicesUrl} auf einem anderen Gerät. Alternativ können Sie auch das Backoffice öffnen, Ihr Projekt öffnen und dort das Geräte Modul aufrufen. Sollte das Geräte Modul nicht sichtbar sein, dann können Sie dies über Projekteinstellungen > Navigation öffnen",
        "devices.pairing.entercode": "Fügen Sie ein neues Gerät hinzu und verwenden Sie den folgenden Code",
        "devices.pairing.generatecode": "Code wird generiert...",
        "devices.pairing.successfullypaired": "Gerät erfolgreich verbunden",
        "devices.pairing.nocontent": "Sie können nun anfangen, Inhalte über das Backoffice auf dieses Gerät zu übertragen"
    };
}
exports.devicesCommon_de_de = devicesCommon_de_de;
